(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haoge-hotspots-counts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haoge-hotspots-counts')) {
    customElements.define('haoge-hotspots-counts', class HaogeHotspotsCounts extends HTMLElement {
      connectedCallback() {
        this.counters = [...this.querySelectorAll('[data-count-target]')];
        this.frames = [];
        this.observer?.disconnect();

        if (!this.counters.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.counters.forEach((counter) => {
          if (Number.isFinite(this.parseTarget(counter.dataset.countTarget))) counter.textContent = '0';
        });

        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.animateCounters();
        }, { threshold: 0.2 });
        this.observer.observe(this.querySelector('.haoge-hotspots-counts__stats'));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.frames?.forEach((frame) => cancelAnimationFrame(frame));
        this.frames = [];
      }

      parseTarget(value) {
        return Number(String(value).replace(/,/g, '').trim());
      }

      animateCounters() {
        const duration = Number(this.dataset.countDuration) || 1600;
        const start = performance.now();

        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);

          this.counters.forEach((counter) => {
            const raw = counter.dataset.countTarget.trim();
            const target = this.parseTarget(raw);
            if (!Number.isFinite(target)) return;

            const decimals = Math.min((raw.split('.')[1] || '').length, 3);
            counter.textContent = progress < 1
              ? (target * eased).toFixed(decimals)
              : raw;
          });

          if (progress < 1) this.frames = [requestAnimationFrame(tick)];
        };

        this.frames = [requestAnimationFrame(tick)];
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haoge-image-link-blocks"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haoge-image-link-slider')) {
    class HaogeImageLinkSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.previousButton = this.querySelector('[data-slider-previous]');
        this.nextButton = this.querySelector('[data-slider-next]');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.onPreviousClick = () => this.move(-1);
        this.onNextClick = () => this.move(1);
        this.onKeyDown = (event) => {
          if (event.key === 'ArrowLeft') this.move(-1);
          if (event.key === 'ArrowRight') this.move(1);
        };

        this.previousButton.addEventListener('click', this.onPreviousClick);
        this.nextButton.addEventListener('click', this.onNextClick);
        this.track.addEventListener('keydown', this.onKeyDown);
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.onPreviousClick);
        this.nextButton?.removeEventListener('click', this.onNextClick);
        this.track?.removeEventListener('keydown', this.onKeyDown);
      }

      move(direction) {
        const firstItem = this.track.querySelector('[data-slider-item]');
        if (!firstItem) return;

        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const step = firstItem.getBoundingClientRect().width + gap;
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const nearStart = this.track.scrollLeft <= 2;
        const nearEnd = this.track.scrollLeft >= maximum - 2;

        if (direction > 0 && nearEnd) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direction < 0 && nearStart) {
          this.track.scrollTo({ left: maximum, behavior: 'smooth' });
        } else {
          this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
        }
      }
    }

    customElements.define('haoge-image-link-slider', HaogeImageLinkSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haoge-impact-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haoge-impact-backdrop')) {
    class HaogeImpactBackdrop extends HTMLElement {
      connectedCallback() {
        this.fitText = this.fitText.bind(this);
        this.resizeObserver = new ResizeObserver(this.fitText);

        if (this.parentElement) {
          this.resizeObserver.observe(this.parentElement);
        }

        this.fitText();
        document.fonts?.ready.then(this.fitText);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      fitText() {
        if (!this.parentElement) return;

        this.style.fontSize = '';

        const availableWidth = Math.max(this.parentElement.clientWidth - 32, 1);
        const naturalWidth = this.scrollWidth;

        if (naturalWidth > availableWidth) {
          const originalSize = Number.parseFloat(window.getComputedStyle(this).fontSize);
          const fittedSize = originalSize * (availableWidth / naturalWidth);
          this.style.fontSize = `${fittedSize}px`;
        }
      }
    }

    customElements.define('haoge-impact-backdrop', HaogeImpactBackdrop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haoge-pro-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haoge-pro-slideshow')) {
    class HaogeProSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.slides = Array.from(this.querySelectorAll('.haoge-pro-slider__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-haoge-dot]'));
        this.previousButton = this.querySelector('[data-haoge-previous]');
        this.nextButton = this.querySelector('[data-haoge-next]');
        this.status = this.querySelector('[data-haoge-status]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.timer = null;
        this.touchStartX = null;
        this.hoverPaused = false;
        this.focusPaused = false;
        this.editorPaused = false;

        this.onPrevious = () => this.goTo(this.currentIndex - 1, true);
        this.onNext = () => this.goTo(this.currentIndex + 1, true);
        this.onKeydown = (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.currentIndex - 1, true);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.currentIndex + 1, true);
          }
        };
        this.onMouseEnter = () => {
          if (this.dataset.pauseOnHover === 'true') {
            this.hoverPaused = true;
            this.stopTimer();
          }
        };
        this.onMouseLeave = () => {
          this.hoverPaused = false;
          this.startTimer();
        };
        this.onFocusIn = () => {
          this.focusPaused = true;
          this.stopTimer();
        };
        this.onFocusOut = () => {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) {
              this.focusPaused = false;
              this.startTimer();
            }
          });
        };
        this.onTouchStart = (event) => {
          if (event.target.closest('a, button')) return;
          this.touchStartX = event.touches[0]?.clientX ?? null;
        };
        this.onTouchEnd = (event) => {
          if (this.touchStartX === null) return;
          const endX = event.changedTouches[0]?.clientX ?? this.touchStartX;
          const distance = endX - this.touchStartX;
          this.touchStartX = null;
          if (Math.abs(distance) < 45) return;
          distance > 0 ? this.goTo(this.currentIndex - 1, true) : this.goTo(this.currentIndex + 1, true);
        };
        this.onVisibilityChange = () => {
          document.hidden ? this.stopTimer() : this.startTimer();
        };
        this.onBlockSelect = (event) => {
          const blockId = event.detail?.blockId;
          const slide = blockId ? this.querySelector(`[data-block-id="${blockId}"]`) : null;
          if (!slide) return;
          this.editorPaused = true;
          this.stopTimer();
          this.goTo(Number(slide.dataset.slideIndex), false);
        };
        this.onBlockDeselect = (event) => {
          const blockId = event.detail?.blockId;
          if (blockId && !this.querySelector(`[data-block-id="${blockId}"]`)) return;
          this.editorPaused = false;
          this.startTimer();
        };

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.haogeDot), true));
        });
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.updateSlides(false);
        this.startTimer();
      }

      disconnectedCallback() {
        this.stopTimer();
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.initialized = false;
      }

      get autoplayEnabled() {
        return this.dataset.autoplay === 'true' && this.slides.length > 1;
      }

      get autoplayDelay() {
        return Math.max(1000, Number(this.dataset.delay) || 6000);
      }

      canAutoplay() {
        return (
          this.autoplayEnabled &&
          !this.hoverPaused &&
          !this.focusPaused &&
          !this.editorPaused &&
          !document.hidden
        );
      }

      startTimer() {
        this.stopTimer();
        if (!this.canAutoplay()) return;
        this.timer = window.setTimeout(() => {
          this.goTo(this.currentIndex + 1, false);
          this.startTimer();
        }, this.autoplayDelay);
      }

      stopTimer() {
        if (this.timer) window.clearTimeout(this.timer);
        this.timer = null;
      }

      goTo(index, userInitiated = false) {
        if (this.slides.length < 2) return;
        const nextIndex = (index + this.slides.length) % this.slides.length;
        if (nextIndex === this.currentIndex) return;
        this.currentIndex = nextIndex;
        this.updateSlides(true);
        if (userInitiated) this.startTimer();
      }

      updateSlides(announce = true) {
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !active;
        });

        this.dots.forEach((dot, index) => {
          const active = index === this.currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (announce && this.status) {
          this.status.textContent = `第 ${this.currentIndex + 1} 张，共 ${this.slides.length} 张`;
        }
      }
    }

    customElements.define('haoge-pro-slideshow', HaogeProSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haoge-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haoge-product-tabs-v2')) {
    customElements.define('haoge-product-tabs-v2', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => {
          if (this.isConnected && !this.abort) this.setup();
        });
      }

      setup() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.tabs = Array.from(this.querySelectorAll('.hps__radio'));
        this.panels = Array.from(this.querySelectorAll('.hps__panel'));
        this.motion = window.matchMedia('(prefers-reduced-motion:reduce)');

        this.addEventListener('click', event => {
          const arrow = event.target.closest('[data-direction]');
          if (arrow) this.navigate(arrow.closest('.hps__panel'), Number(arrow.dataset.direction));
        }, { signal });

        this.addEventListener('change', event => {
          if (event.target.matches('.hps__radio')) this.scheduleArrows();
        }, { signal });

        this.addEventListener('keydown', event => {
          const tab = event.target.closest('.hps__radio');
          if (tab && this.tabs.includes(tab)) {
            let index = this.tabs.indexOf(tab);
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowRight') index += rtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') index += rtl ? 1 : -1;
            else if (event.key === 'Home') index = 0;
            else if (event.key === 'End') index = this.tabs.length - 1;
            else return;
            event.preventDefault();
            const next = this.tabs[(index + this.tabs.length) % this.tabs.length];
            this.activate(next.dataset.tabId, true);
          } else if (event.target.matches('.hps__track')) {
            const track = event.target;
            const panel = track.closest('.hps__panel');
            const rtl = getComputedStyle(track).direction === 'rtl';
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
              event.preventDefault();
              this.navigate(panel, (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
            } else if (event.key === 'Home' || event.key === 'End') {
              event.preventDefault();
              const cards = Array.from(track.children);
              this.scrollToCard(track, event.key === 'Home' ? cards[0] : cards[cards.length - 1]);
            }
          }
        }, { signal });

        this.addEventListener('submit', event => {
          const form = event.target.closest('.hps__form');
          if (!form || event.defaultPrevented) return;
          if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
          form.dataset.submitting = 'true';
          form.querySelector('[type="submit"]').disabled = true;
        }, { signal });

        window.addEventListener('pageshow', () => {
          this.querySelectorAll('.hps__form[data-submitting]').forEach(form => {
            delete form.dataset.submitting;
            form.querySelector('[type="submit"]').disabled = false;
          });
        }, { signal });

        document.addEventListener('shopify:block:select', event => {
          const id = event.detail?.blockId;
          if (this.tabs.some(tab => tab.dataset.tabId === id)) this.activate(id);
        }, { signal });

        this.panels.forEach(panel => {
          panel.querySelector('.hps__track').addEventListener('scroll', () => this.scheduleArrows(), { signal, passive: true });
        });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleArrows());
          this.panels.forEach(panel => this.resizeObserver.observe(panel.querySelector('.hps__track')));
        } else window.addEventListener('resize', () => this.scheduleArrows(), { signal });
        this.activate(this.tabs.find(tab => tab.checked)?.dataset.tabId || this.tabs[0]?.dataset.tabId);
      }

      activate(id, focus = false) {
        if (!id) return;
        this.tabs.forEach(tab => {
          const selected = tab.dataset.tabId === id;
          tab.checked = selected;
          if (selected && focus) {
            tab.focus({ preventScroll: true });
            const wrap = this.querySelector('.hps__tabs-wrap');
            const box = tab.labels[0].getBoundingClientRect();
            const bounds = wrap.getBoundingClientRect();
            if (box.left < bounds.left) wrap.scrollBy({ left: box.left - bounds.left });
            if (box.right > bounds.right) wrap.scrollBy({ left: box.right - bounds.right });
          }
        });
        this.scheduleArrows();
      }

      scheduleArrows() {
        cancelAnimationFrame(this.arrowsFrame);
        this.arrowsFrame = requestAnimationFrame(() => this.updateArrows());
      }

      updateArrows() {
        const activeId = this.tabs.find(tab => tab.checked)?.dataset.tabId;
        this.panels.filter(panel => panel.dataset.panelId === activeId).forEach(panel => {
          const track = panel.querySelector('.hps__track');
          const overflow = track.scrollWidth - track.clientWidth;
          const position = Math.abs(track.scrollLeft);
          panel.querySelectorAll('[data-direction]').forEach(arrow => {
            arrow.hidden = overflow < 3;
            arrow.disabled = Number(arrow.dataset.direction) < 0 ? position < 3 : position >= overflow - 3;
          });
        });
      }

      navigate(panel, direction) {
        if (!panel) return;
        const track = panel.querySelector('.hps__track');
        const cards = Array.from(track.children);
        const bounds = track.getBoundingClientRect();
        const rtl = getComputedStyle(track).direction === 'rtl';
        let index = 0;
        let closest = Infinity;
        cards.forEach((card, i) => {
          const box = card.getBoundingClientRect();
          const delta = Math.abs(rtl ? box.right - bounds.right : box.left - bounds.left);
          if (delta < closest) { index = i; closest = delta; }
        });
        this.scrollToCard(track, cards[Math.max(0, Math.min(cards.length - 1, index + direction))]);
      }

      scrollToCard(track, card) {
        if (!card) return;
        const bounds = track.getBoundingClientRect();
        const box = card.getBoundingClientRect();
        const rtl = getComputedStyle(track).direction === 'rtl';
        track.scrollBy({ left: rtl ? box.right - bounds.right : box.left - bounds.left, behavior: this.motion.matches ? 'auto' : 'smooth' });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.arrowsFrame);
        this.abort?.abort();
        this.abort = null;
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haoge-scrolling-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haoge-marquee')) {
    class HaogeMarquee extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-marquee-rail]');
        this.group = this.querySelector('[data-marquee-group]');
        this.copyTemplate = this.querySelector('.haoge-scrolling-text__group[aria-hidden="true"]');

        if (!this.rail || !this.group || !this.copyTemplate) return;

        this.speed = Number.parseFloat(this.dataset.speed) || 80;
        this.direction = this.dataset.direction || 'left';
        this.distance = 0;
        this.lastTimestamp = null;
        this.isPaused = false;

        this.rebuild = this.rebuild.bind(this);
        this.animate = this.animate.bind(this);
        this.pause = () => {
          this.isPaused = true;
          this.lastTimestamp = null;
        };
        this.play = () => {
          this.isPaused = false;
          this.lastTimestamp = null;
        };

        this.resizeObserver = new ResizeObserver(this.rebuild);
        this.resizeObserver.observe(this.group);
        this.resizeObserver.observe(this);
        this.rebuild();

        if (this.classList.contains('haoge-scrolling-text__viewport--pause')) {
          this.addEventListener('mouseenter', this.pause);
          this.addEventListener('mouseleave', this.play);
          this.addEventListener('focusin', this.pause);
          this.addEventListener('focusout', this.play);
        }

        this.animationFrame = requestAnimationFrame(this.animate);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.animationFrame);
        this.removeEventListener('mouseenter', this.pause);
        this.removeEventListener('mouseleave', this.play);
        this.removeEventListener('focusin', this.pause);
        this.removeEventListener('focusout', this.play);
      }

      rebuild() {
        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth) return;

        this.querySelectorAll('[data-generated-copy]').forEach((copy) => copy.remove());

        const requiredGroups = Math.max(2, Math.ceil(this.clientWidth / groupWidth) + 2);
        for (let index = 2; index < requiredGroups; index += 1) {
          const copy = this.copyTemplate.cloneNode(true);
          copy.dataset.generatedCopy = '';
          this.rail.appendChild(copy);
        }

        this.loopWidth = groupWidth;
        this.distance %= groupWidth;
      }

      animate(timestamp) {
        if (!this.loopWidth) {
          this.animationFrame = requestAnimationFrame(this.animate);
          return;
        }

        if (this.lastTimestamp === null) this.lastTimestamp = timestamp;

        const elapsed = Math.min((timestamp - this.lastTimestamp) / 1000, 0.1);
        this.lastTimestamp = timestamp;

        if (!this.isPaused) {
          this.distance = (this.distance + this.speed * elapsed) % this.loopWidth;
        }

        const offset = this.direction === 'right'
          ? this.distance - this.loopWidth
          : -this.distance;

        this.rail.style.transform = `translate3d(${offset}px, 0, 0)`;
        this.animationFrame = requestAnimationFrame(this.animate);
      }
    }

    customElements.define('haoge-marquee', HaogeMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haoge-social-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haoge-social-videos')) {
    customElements.define('haoge-social-videos', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => {
          if (!this.isConnected || this.abort) return;
          this.setup();
        });
      }

      setup() {
        this.track = this.querySelector('.hsv__track');
        if (!this.track) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.cards = Array.from(this.querySelectorAll('.hsv__card'));
        this.arrows = Array.from(this.querySelectorAll('[data-direction]'));
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.addEventListener('click', event => {
          const play = event.target.closest('[data-play]');
          const close = event.target.closest('.hsv__close');
          const arrow = event.target.closest('[data-direction]');
          if (play) this.playCard(play.closest('.hsv__card'));
          if (close) this.stopCard(close.closest('.hsv__card'), true);
          if (arrow) this.navigate(Number(arrow.dataset.direction));
        }, { signal });

        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            this.navigate((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.scrollToCard(event.key === 'Home' ? this.cards[0] : this.cards[this.cards.length - 1]);
          }
        }, { signal });

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateArrows());
        }, { signal, passive: true });

        document.addEventListener('haoge:social-video-play', event => {
          this.cards.forEach(card => { if (card !== event.detail.card) this.stopCard(card); });
        }, { signal });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.cards.forEach(card => this.stopCard(card));
        }, { signal });

        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (card) this.scrollToCard(card, 'auto');
        }, { signal });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateArrows());
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.updateArrows(), { signal });
        }

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting || entry.intersectionRatio < .2) {
                if (!entry.target.querySelector(':fullscreen')) this.stopCard(entry.target);
              }
            });
          }, { threshold: [0, .2] });
          this.cards.forEach(card => this.visibilityObserver.observe(card));
        }
        this.updateArrows();
      }

      youtubeId(value) {
        try {
          const url = new URL(value);
          if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
          const host = url.hostname.toLowerCase();
          const parts = url.pathname.split('/').filter(Boolean);
          let id = '';
          if (host === 'youtu.be') id = parts[0] || '';
          else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
            if (parts[0] === 'watch') id = url.searchParams.get('v') || '';
            else if (['shorts', 'embed', 'live'].includes(parts[0])) id = parts[1] || '';
          }
          return /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
        } catch (_) { return null; }
      }

      showError(card, message) {
        const error = card.querySelector('.hsv__error');
        error.textContent = message;
        error.hidden = false;
      }

      playCard(card) {
        if (!card || card.dataset.playing === 'true') return;
        card.querySelector('.hsv__error').hidden = true;
        if (card.dataset.configured !== 'true') {
          this.showError(card, '请先在此视频区块的设置中选择视频或填写链接。');
          return;
        }
        const player = card.querySelector('.hsv__player');
        let media;
        if (card.dataset.source === 'upload') {
          media = card.querySelector('template')?.content.querySelector('video')?.cloneNode(true);
          if (!media) return;
          media.muted = this.dataset.muted === 'true';
          media.loop = this.dataset.loop === 'true';
          media.controls = true;
          media.playsInline = true;
          media.preload = 'metadata';
          media.setAttribute('aria-label', card.dataset.title);
          media.addEventListener('error', () => {
            if (card.dataset.playing === 'true') {
              this.showError(card, 'This video could not load. Please try again or use the original link.');
            }
          });
        } else if (card.dataset.source === 'youtube') {
          const id = this.youtubeId(card.dataset.url);
          if (!id) {
            this.showError(card, 'Please enter a valid YouTube or YouTube Shorts link in the video settings.');
            return;
          }
          media = document.createElement('iframe');
          const params = new URLSearchParams({ autoplay: '1', playsinline: '1', rel: '0', mute: this.dataset.muted === 'true' ? '1' : '0' });
          if (this.dataset.loop === 'true') { params.set('loop', '1'); params.set('playlist', id); }
          media.src = `https://www.youtube-nocookie.com/embed/${id}?${params}`;
          media.title = card.dataset.title;
          media.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          media.allowFullscreen = true;
          media.referrerPolicy = 'strict-origin-when-cross-origin';
        } else { return; }

        document.dispatchEvent(new CustomEvent('haoge:social-video-play', { detail: { card } }));
        player.replaceChildren(media);
        player.hidden = false;
        card.dataset.playing = 'true';
        card.querySelector('.hsv__poster').hidden = true;
        card.querySelector('.hsv__close').hidden = false;
        card.querySelector('.hsv__close').focus({ preventScroll: true });
        if (media.tagName === 'VIDEO') {
          const attempt = media.play();
          if (attempt) attempt.catch(() => {
            if (card.dataset.playing === 'true') this.showError(card, 'Tap the video play button to start.');
          });
        }
      }

      stopCard(card, restoreFocus = false) {
        if (!card || card.dataset.playing !== 'true') return;
        card.dataset.playing = 'false';
        const player = card.querySelector('.hsv__player');
        const video = player.querySelector('video');
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          video.load();
        }
        player.replaceChildren();
        player.hidden = true;
        card.querySelector('.hsv__poster').hidden = false;
        card.querySelector('.hsv__close').hidden = true;
        card.querySelector('.hsv__error').hidden = true;
        if (restoreFocus) card.querySelector('.hsv__poster').focus({ preventScroll: true });
      }

      leadingIndex() {
        const rect = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let index = 0;
        let distance = Infinity;
        this.cards.forEach((card, i) => {
          const box = card.getBoundingClientRect();
          const delta = Math.abs(rtl ? rect.right - box.right : box.left - rect.left);
          if (delta < distance) { index = i; distance = delta; }
        });
        return index;
      }

      navigate(direction) {
        const index = Math.max(0, Math.min(this.cards.length - 1, this.leadingIndex() + direction));
        this.scrollToCard(this.cards[index]);
      }

      scrollToCard(card, behavior) {
        if (!card) return;
        const rect = this.track.getBoundingClientRect();
        const box = card.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: rtl ? box.right - rect.right : box.left - rect.left, behavior: behavior || (this.motion.matches ? 'auto' : 'smooth') });
      }

      updateArrows() {
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.arrows.forEach(arrow => {
          arrow.hidden = overflow < 3;
          arrow.disabled = Number(arrow.dataset.direction) < 0 ? position < 3 : position >= overflow - 3;
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.abort?.abort();
        this.abort = null;
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.cards?.forEach(card => this.stopCard(card));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
